<!-- eslint-disable max-len !-->
<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <div class="d-flex m__b--20">
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'sent'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('sent')">
        SENT
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'approved'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('approved')">
        APPROVED
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'rejected'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('rejected')">
        REJECTED
      </div>
    </div>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openDetail">
      <div
        slot="date"
        slot-scope="props">
        {{ props.row.category_id === '9' ? props.row.tanggal_pelanggaran : props.row.tanggal_penyelanggaraan }}
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Buku Saku Siswa',
      },
      tabSelected: 'sent',
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['id', 'nis', 'title', 'category_name', 'date'],
      options: {
        headings: {
          id: 'ID',
          nis: 'NIS',
          title: 'TITLE',
          category_name: 'CATEGORY',
          date: 'DATE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            status: data.status,
            module_id: 5,
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListDocumentApp(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    selectTab(status) {
      this.tabSelected = status;
      this.$refs.tableServer.getData();
    },

    loading(val) {
      const a = val;
      a.status = this.tabSelected;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    openDetail(param) {
      this.$router.replace(`/buku-saku-siswa/approver/detail/${param.row.id}/${this.tabSelected}`);
    },
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/approver/jBukuSakuApp.vue